import React, { Component } from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import { ReviewFileCommentDbDto } from "../common/dto/ReviewFileCommentDbDto";
import ReviewFile from "./ReviewFile";

type Props = { reviewId: string }
type Event = { preventDefault: () => void }
type State = {
    fileList: string[],
    fileContents: string,
    selectedFileName: string,
    comments: ReviewFileCommentDbDto[],
}

export default class ReviewFileList extends Component<ServiceCollectionParam & Props, State> {

    state: State = {
        fileList: [],
        fileContents: '',
        selectedFileName: '',
        comments: []
    }

    async selectFile(e: Event, fileName: string) {
        e.preventDefault();

        let index = this.state.fileList.indexOf(fileName);

        let contents = await this.props.services.dao
            .findReviewFile(this.props.reviewId, index);

        this.state.selectedFileName = fileName;
        this.state.fileContents = contents;

        this.state.comments = await this.props.services.dao
            .findReviewFileComments(this.props.reviewId);

        this.setState(this.state);
    }

    async componentDidMount() {
        let reviewId = this.props.reviewId;

        let fileList = await this.props.services.dao.findReviewFileList(reviewId);

        this.state.fileList = fileList;

        this.setState(this.state);
    }

    async saveComment(comment: ReviewFileCommentDbDto) {
        let commentId = comment._id;

        if (!commentId && isMissingOrBlank(comment.text)) {
            return;
        } else if (commentId && isMissingOrBlank(comment.text)) {
            await this.props.services.dao
                .deleteReviewFileComment(commentId);
        } else {
            await this.props.services.dao
                .saveReviewFileComment(this.props.reviewId, comment);
        }

        this.state.comments = await this.props.services.dao
            .findReviewFileComments(this.props.reviewId);

        this.setState(this.state);
    }

    truncateJavaPath(path: string): string {
        return path.replace(/.*src\/main\/java\//, '');
    }

    render() {
        let index = 0;

        return (
            <>

            <div className="file-list">
            { this.state.fileList.map(file =>
                <div key={index++} >
                    <a href="" onClick={ e => this.selectFile(e, file) }>{
                        this.truncateJavaPath(file) }</a>
                </div>)
            }
            </div>

            <hr />

            <ReviewFile fileName={ this.state.selectedFileName }
                        fileContents={ this.state.fileContents }
                        comments={ this.state.comments }
                        saveCommentCb={ comment => this.saveComment(comment) } />
            </>
        );
    }
}

function isMissingOrBlank(text: string) {
    return !text || text.trim() === '';
}
